(function($){

	$( document ).ready(function() {
		var queryKey = 'enquiry-type';
		var params = new URLSearchParams(window.location.search);

		if (!params.has(queryKey)) {
			return;
		}

		var queryValue = params.get(queryKey);

		if (!queryValue) {
			return;
		}

		var $fields = $('[name="' + queryKey + '"]');

		if (!$fields.length) {
			return;
		}

		var $field = $fields.first();
		var tagName = ($field.prop('tagName') || '').toLowerCase();
		var fieldType = ($field.attr('type') || '').toLowerCase();

		if (tagName === 'select') {
			var $matchedOption = $field.find('option').filter(function() {
				var $option = $(this);
				return $option.val() === queryValue || $.trim($option.text()) === queryValue;
			}).first();

			if ($matchedOption.length) {
				$field.val($matchedOption.val()).trigger('change');
			}

			return;
		}

		if (fieldType === 'radio') {
			var $matchedRadio = $fields.filter('[value="' + queryValue.replace(/"/g, '\\"') + '"]');

			if ($matchedRadio.length) {
				$matchedRadio.prop('checked', true).trigger('change');
			}

			return;
		}

		if (fieldType === 'checkbox') {
			var $matchedCheckbox = $fields.filter('[value="' + queryValue.replace(/"/g, '\\"') + '"]');

			if ($matchedCheckbox.length) {
				$matchedCheckbox.prop('checked', true).trigger('change');
			}

			return;
		}

		$field.val(queryValue).trigger('change');

    });

})(jQuery);